'use client';

import * as React from 'react';
import { createSvgIcon } from '../../utils';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');


//////////////////
// WEBPACK FOOTER
// ../@mui/material/internal/svg-icons/Add.js
// module id = 1823
// module chunks = 22